"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShuffleTileOptionType = void 0;
var ShuffleTileOptionType;
(function (ShuffleTileOptionType) {
    ShuffleTileOptionType["NONE"] = "None";
    ShuffleTileOptionType["LIMITED_RANDOM"] = "Procedurally";
    ShuffleTileOptionType["FULL_RANDOM"] = "Full random";
})(ShuffleTileOptionType = exports.ShuffleTileOptionType || (exports.ShuffleTileOptionType = {}));
//# sourceMappingURL=ShuffleTileOptionType.js.map